const emptyHtml = `<style>.content{width: 100%; height: 100vh; display: flex; align-items: center; justify-content: center;}</style><div class="content"><h3>Sem conteúdo para exibir.</h3></div>`;

export default emptyHtml;
